/* eslint-disable prettier/prettier */
import CustomDatePicker from 'components/datepicker'
import { Button, InputField } from 'components/form-inputs'
import { useFormik } from 'formik'
import { newCustomerEntriesService } from 'services'
import { _object } from 'utils/interfaces'
import * as Yup from 'yup'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-number-input'

export default function EditNewCustomer() {
  const [newCustomer, setNewCustomer] = useState<_object>({})
  const [loading, setLoading] = useState(false)

  const newCustomerDetails = () => {
    setLoading(true)
    newCustomerEntriesService.getNewCustomerDetails(id).then((results: _object) => {
      setNewCustomer(results)
    })
    setLoading(false)
  }
  useEffect(() => {
    newCustomerDetails()
  }, [])

  const { id } = useParams()
  const formik: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: newCustomer.email || '',
      username: newCustomer.username || '',
      applicant_fullname: newCustomer.applicant_fullname || '',
      acn_abn: newCustomer.acn_abn || '',
      trading_name: newCustomer.trading_name || '',
      legal_structure: newCustomer.legal_structure || '',
      trust_name: newCustomer.trust_name || '',
      business_address1: newCustomer.business_address1 || '',
      business_address2: newCustomer.business_address2 || '',
      business_contact_person: newCustomer.business_contact_person || '',
      business_phone: newCustomer.business_phone || '',
      business_fax: newCustomer.business_fax || '',
      director1_name: newCustomer.director1_name || '',
      director1_dob: newCustomer.director1_dob || '',
      director1_position: newCustomer.director1_position || '',
      director1_driver_license: newCustomer.director1_driver_license || '',
      director1_address: newCustomer.director1_address || '',
      director1_mobile: newCustomer.director1_mobile || '',
      director2_name: newCustomer.director2_name || '',
      director2_dob: newCustomer.director2_dob || '',
      director2_position: newCustomer.director2_position || '',
      director2_driver_license: newCustomer.director2_driver_license || '',
      director2_address: newCustomer.director2_address || '',
      director2_mobile: newCustomer.director2_mobile || '',
      purchasing_contact_person: newCustomer.purchasing_contact_person || '',
      accounts_payable_contact_person: newCustomer.accounts_payable_contact_person || '',
      date_business_commenced: newCustomer.date_business_commenced || '',
      expected_monthly_purchases: newCustomer.expected_monthly_purchases || '',
      nature_of_business: newCustomer.nature_of_business || '',
      any_judgement_entered_against_applicant:
        newCustomer.any_judgement_entered_against_applicant || '',
      name_of_bank: newCustomer.name_of_bank || '',
      bank_branch: newCustomer.bank_branch || '',
      bank_account_number: newCustomer.bank_account_number || '',
      bank_bsb: newCustomer.bank_bsb || '',
      trade_supplier1_name: newCustomer.trade_supplier1_name || '',
      trade_supplier1_phone: newCustomer.trade_supplier1_phone || '',
      trade_supplier1_address: newCustomer.trade_supplier1_address || '',
      trade_supplier1_contact_person: newCustomer.trade_supplier1_contact_person || '',
      trade_supplier2_name: newCustomer.trade_supplier2_name || '',
      trade_supplier2_phone: newCustomer.trade_supplier2_phone || '',
      trade_supplier2_address: newCustomer.trade_supplier2_address || '',
      trade_supplier2_contact_person: newCustomer.trade_supplier2_contact_person || '',
      // trade_supplier_phone: newCustomer.trade_supplier_phone || '',
      status: newCustomer.status
    },

    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Required'),
      username: Yup.string().required('Required')
      // applicant_fullname: Yup.string().required('Required'),
      // acn_abn: Yup.string().required('Required'),
      // trading_name: Yup.string().required('Required'),
      // legal_structure: Yup.string().required('Required'),
      // trust_name: Yup.string().required('Required'),
      // business_address1: Yup.string().required('Required'),
      // business_address2: Yup.string().required('Required'),
      // business_contact_person: Yup.string().required('Required'),
      // business_phone: Yup.string().required('Required'),
      // business_fax: Yup.string().required('Required'),
      // director1_name: Yup.string().required('Required'),
      // director1_dob: Yup.string().required('Required'),
      // director1_position: Yup.string().required('Required'),
      // director1_driver_license: Yup.string().required('Required'),
      // director1_address: Yup.string().required('Required'),
      // director1_mobile: Yup.string().required('Required'),
      // director2_name: Yup.string().required('Required'),
      // director2_dob: Yup.string().required('Required'),
      // director2_position: Yup.string().required('Required'),
      // director2_driver_license: Yup.string().required('Required'),
      // director2_address: Yup.string().required('Required'),
      // director2_mobile: Yup.string().required('Required'),
      // purchasing_contact_person: Yup.string().required('Required'),
      // accounts_payable_contact_person: Yup.string().required('Required'),
      // date_business_commenced: Yup.string().required('Required'),
      // expected_monthly_purchases: Yup.number().required('Required'),
      // nature_of_business: Yup.string().required('Required'),
      // any_judgement_entered_against_applicant: Yup.string().required('Required'),
      // name_of_bank: Yup.string().required('Required'),
      // bank_branch: Yup.string().required('Required'),
      // bank_account_number: Yup.string().required('Required'),
      // bank_bsb: Yup.string().required('Required'),
      // trade_supplier1_name: Yup.string().required('Required'),
      // trade_supplier1_phone: Yup.string().required('Required'),
      // trade_supplier1_address: Yup.string().required('Required'),
      // trade_supplier1_contact_person: Yup.string().required('Required'),
      // trade_supplier2_name: Yup.string().required('Required'),
      // trade_supplier2_phone: Yup.string().required('Required'),
      // trade_supplier2_address: Yup.string().required('Required'),
      // trade_supplier2_contact_person: Yup.string().required('Required')
    }),
    onSubmit: (values) => {
      newCustomerEntriesService.UpdateNewCustomer(id, values).then((results: _object) => {
        if (results.error === false) {
          newCustomerDetails()
        }
      })
    }
  })

  return (
    <>
      <form
        onSubmit={formik.handleSubmit}
        className="mx-auto max-w-7xl rounded bg-white p-6 shadow"
      >
        <h2 className="mb-6 text-center text-2xl font-bold">Customer Information</h2>
        <h3 className="mt-10 mb-4 text-lg font-semibold">Account Details</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            label="User Name"
            name="username"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.username}
            required
            error={formik.touched.username && formik.errors.username}
          />
          <InputField
            label="Email"
            name="email"
            placeholder="Enter Here"
            type="email"
            onChange={formik.handleChange}
            value={formik.values.email}
            required
            error={formik.touched.email && formik.errors.email}
          />
          <InputField
            label="Full Name"
            name="applicant_fullname"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.applicant_fullname}
          />
        </div>
        <h3 className="mt-10 mb-4 text-lg font-semibold">Applicant Details</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            label="ACN / ABN"
            type="number"
            name="acn_abn"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.acn_abn}
          />
          <InputField
            label="Trading Name"
            name="trading_name"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.trading_name}
          />
          <InputField
            label="Legal Structure"
            name="legal_structure"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.legal_structure}
          />
          <InputField
            label="Trust Name"
            name="trust_name"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.trust_name}
          />
          <InputField
            label="Business Address 1"
            name="business_address1"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.business_address1}
          />
          <InputField
            label="Business Address 2"
            name="business_address2"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.business_address2}
          />
          <InputField
            label="Business Contact Person"
            name="business_contact_person"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.business_contact_person}
          />
          <div className="w-full">
            <label
              htmlFor="business_phone"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            <PhoneInput
              id="business_phone"
              name="business_phone"
              defaultCountry="AU"
              value={formik.values.business_phone}
              onChange={(value) => formik.setFieldValue('business_phone', value)}
              className="min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none false  border-transparent "
            />
          </div>

          <InputField
            label="Business Fax"
            type="number"
            name="business_fax"
            placeholder="Enter Here"
            onChange={formik.handleChange}
            value={formik.values.business_fax}
          />
        </div>

        <h3 className="mt-10 mb-4 text-lg font-semibold">Director 1 Details</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            label="Full Name"
            name="director1_name"
            onChange={formik.handleChange}
            value={formik.values.director1_name}
          />
          <CustomDatePicker
            label="Date of Birth"
            name="director1_dob"
            value={formik.values.director1_dob}
            onChange={formik.handleChange}
          />
          <InputField
            label="Position"
            name="director1_position"
            onChange={formik.handleChange}
            value={formik.values.director1_position}
          />
          <InputField
            label="Driver License"
            name="director1_driver_license"
            onChange={formik.handleChange}
            value={formik.values.director1_driver_license}
          />
          <InputField
            label="Address"
            name="director1_address"
            onChange={formik.handleChange}
            value={formik.values.director1_address}
          />
          <div className="w-full">
            <label
              htmlFor="business_phone"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            <PhoneInput
              defaultCountry="AU"
              value={formik.values.director1_mobile}
              onChange={(value) => formik.setFieldValue('director1_mobile', value)}
              international={false} // Optional: set to true if you want intl format
              countryCallingCodeEditable={false}
              className="min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none border-transparent  PhoneInput"
            />
          </div>
        </div>

        <h3 className="mt-10 mb-4 text-lg font-semibold">Director 2 Details</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            label="Full Name"
            name="director2_name"
            onChange={formik.handleChange}
            value={formik.values.director2_name}
          />
          <CustomDatePicker
            className=""
            label="Date of Birth"
            name="director2_dob"
            value={formik.values.director2_dob}
            onChange={formik.handleChange}
          />
          <InputField
            label="Position"
            name="director2_position"
            onChange={formik.handleChange}
            value={formik.values.director2_position}
          />
          <InputField
            label="Driver License"
            name="director2_driver_license"
            onChange={formik.handleChange}
            value={formik.values.director2_driver_license}
          />
          <InputField
            label="Address"
            name="director2_address"
            onChange={formik.handleChange}
            value={formik.values.director2_address}
          />
          <div className="w-full">
            <label
              htmlFor="business_phone"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            <PhoneInput
              country={'au'}
              value={formik.values.director2_mobile}
              onChange={(value) => formik.setFieldValue('director2_mobile', value)}
              inputProps={{
                name: 'director2_mobile',
                required: true
              }}
              className="min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none false  border-transparent  PhoneInput"
              autoFormat={false}
            />
          </div>
        </div>

        <h3 className="mt-10 mb-4 text-lg font-semibold">Business Operations</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            label="Purchasing Contact Person"
            name="purchasing_contact_person"
            onChange={formik.handleChange}
            value={formik.values.purchasing_contact_person}
          />
          <InputField
            label="Accounts Payable Contact"
            name="accounts_payable_contact_person"
            onChange={formik.handleChange}
            value={formik.values.accounts_payable_contact_person}
          />
          <CustomDatePicker
            className=""
            label="Date Business Commenced"
            name="date_business_commenced"
            value={formik.values.date_business_commenced}
            onChange={formik.handleChange}
          />
          <InputField
            label="Expected Monthly Purchases"
            name="expected_monthly_purchases"
            type="number"
            onChange={formik.handleChange}
            value={formik.values.expected_monthly_purchases}
          />
          <InputField
            label="Nature of Business"
            name="nature_of_business"
            onChange={formik.handleChange}
            value={formik.values.nature_of_business}
          />
          <InputField
            label="Any Judgement Against Applicant?"
            name="any_judgement_entered_against_applicant"
            onChange={formik.handleChange}
            value={formik.values.any_judgement_entered_against_applicant}
          />
        </div>

        <h3 className="mt-10 mb-4 text-lg font-semibold">Bank Details</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <InputField
            label="Bank Name"
            name="name_of_bank"
            onChange={formik.handleChange}
            value={formik.values.name_of_bank}
          />
          <InputField
            label="Branch"
            name="bank_branch"
            onChange={formik.handleChange}
            value={formik.values.bank_branch}
          />
          <InputField
            label="Account Number"
            type="number"
            name="bank_account_number"
            onChange={formik.handleChange}
            value={formik.values.bank_account_number}
          />
          <InputField
            label="BSB"
            name="bank_bsb"
            onChange={formik.handleChange}
            value={formik.values.bank_bsb}
          />
        </div>

        <h3 className="mt-10 mb-0 text-lg font-semibold">Trade References</h3>
        {/* <p className="mt-0 mb-3 text-sm font-normal text-gray-600">First supplier</p> */}
        <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-4">
          <InputField
            label=" First Supplier Name"
            name="trade_supplier1_name"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier1_name}
          />
          <div className="w-full">
            <label
              htmlFor="business_phone"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              First Supplier Phone Number
            </label>
            <PhoneInput
              country={'au'}
              value={formik.values.trade_supplier1_phone}
              onChange={(value) => formik.setFieldValue('trade_supplier1_phone', value)}
              inputProps={{
                name: 'trade_supplier1_phone',
                required: true
              }}
              className="min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none  border-transparent  PhoneInput"
              autoFormat={false}
            />
          </div>
          <InputField
            label="First Supplier Address"
            name="trade_supplier1_address"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier1_address}
          />
          <InputField
            label="First Supplier Contact Person"
            name="trade_supplier1_contact_person"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier1_contact_person}
          />
        </div>
        {/* <p className="mt-0 mb-3 text-sm font-normal text-gray-600">Second supplier</p> */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <InputField
            label="Second Supplier Name"
            name="trade_supplier2_name"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier2_name}
          />
          <div className="w-full">
            <label
              htmlFor="business_phone"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Second Supplier Phone Number
            </label>
            <PhoneInput
              country={'au'}
              value={formik.values.trade_supplier2_phone}
              onChange={(value) => formik.setFieldValue('trade_supplier2_phone', value)}
              inputProps={{
                name: 'trade_supplier2_phone',
                required: true
              }}
              className="min-h-10 w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none border-transparent  PhoneInput"
              autoFormat={false}
            />
          </div>
          <InputField
            label="Second Supplier Address"
            name="trade_supplier2_address"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier2_address}
          />
          <InputField
            label="Second Supplier Contact Person"
            name="trade_supplier2_contact_person"
            onChange={formik.handleChange}
            value={formik.values.trade_supplier2_contact_person}
          />
          <div className="grid">
            {/* <label className="mb-2 flex text-sm leading-none font-bold text-gray-700">Status</label> */}
            <h3 className="my-4 text-lg font-semibold">Status</h3>
            <div className="flex gap-6">
              <label className="flex items-center gap-2 text-sm text-gray-700">
                <input
                  type="radio"
                  name="status"
                  value="pending"
                  checked={formik.values.status === 'pending'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                Pending
              </label>

              <label className="flex items-center gap-2 text-sm text-gray-700">
                <input
                  type="radio"
                  name="status"
                  value="completed"
                  checked={formik.values.status === 'completed'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                Completed
              </label>
            </div>
          </div>
        </div>
        <div>
          <Button
            label="Submit"
            type="submit"
            className="mx-auto mt-4 block w-[100px] rounded-lg bg-purple-900 py-2 text-sm text-white transition hover:bg-purple-950"
            loading={loading}
            disabled={!formik.isValid || !formik.dirty}
          />
        </div>
      </form>
    </>
  )
}
